export const LOADING_LABS = 'LOADING_LABS';
export const GET_LABS = 'GET_LABS';
export const SAVE_LOADING_LABS = 'SAVE_LOADING_LABS';
export const FORM_FAIL = "FORM_FAIL";
export const LABS_FAIL = "LABS_FAIL";
